// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarAnunciosService = async () => {
  const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/venda`;

  const Token = validateToken();

  if(Token){
     try {
    const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }

  }else{
    console.error("Token inválido ou expirado.");
  }
 
};

/**
 * Busca o cotaUsuarioId relacionado a um determinado anuncioId
 * @param anuncioId número do anúncio
 * @returns objeto com o cotaUsuarioId ou null
 */
export const buscarCotaUsuarioPorAnuncioService = async (anuncioId: number) => {
  const URL = `${Globais.DOMINIOBACK}/anuncio-propriedade/${anuncioId}/cota`;

  const Token = validateToken();

  if (Token) {
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data; // { cotaUsuarioId: number }
      }
    } catch (error: any) {
      console.error("Erro ao buscar cotaUsuarioId por anuncioId:", error.response?.data || error.message);
      return null;
    }
  } else {
    console.error("Token inválido ou expirado.");
    return null;
  }
}
